<div class="layout-wrapper" [ngClass]="containerClass">
  <ng-container *ngIf="!webviewService.isWebview; else webviewOnly">
    <div
      class="layout-shell"
      [class.layout-shell--panel-open]="detailPanelOpen">
      <aside class="layout-shell__nav">
        <app-sidebar></app-sidebar>
      </aside>

      <div class="layout-shell__main">
        <app-topbar></app-topbar>
        <div class="layout-shell__content">
          <router-outlet></router-outlet>
        </div>
        <app-footer></app-footer>
      </div>
    </div>
  </ng-container>

  <ng-template #webviewOnly>
    <div class="layout-shell layout-shell--webview">
      <div class="layout-shell__content layout-shell__content--webview">
        <router-outlet></router-outlet>
      </div>
    </div>
  </ng-template>

  <div class="layout-mask"></div>
</div>
